import styled from 'styled-components'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #D4D4D6;
  background: #FFF;
`

export const StyledPrice = styled.span`
  margin-left: 8px;
  padding-left: 8px;
  border-left: 1px solid #BEBEC1;
`

export const StyledWarrantyInfo = styled.div`
  margin-left: 32px;
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 165%;
`

export const StyledLearnMoreButton = styled.button`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 165%;
  text-decoration-line: underline;
  padding: 0;
  border: none;
  cursor: pointer;
  background: white;
`

export const StyledLearnMoreModalSubtitle = styled.div`
  color: #3E3E47;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 165%;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 8px;
  margin-bottom: 16px;
`

export const StyledCheckboxLabel = styled.div`
  color: #3E3E47;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 165%;
  padding-left: 6px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    font-size: 16px;
  }
`
